import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Plus, Check, ExternalLink, Trash2 } from 'lucide-react';

const MAX_ROWS = 300;

const Row = ({ a, selected, onToggle, onFocus }) => (
  <li className={`flex items-center gap-2 px-2 py-2 rounded-lg transition-colors ${selected ? 'bg-blue-50' : 'hover:bg-slate-50'}`} data-testid={`map-list-item-${a.id}`}>
    <button onClick={() => onToggle(a)} className={`w-6 h-6 shrink-0 rounded-md border flex items-center justify-center ${selected ? 'bg-blue-600 border-blue-600 text-white' : 'border-slate-300 text-slate-400 hover:border-blue-400'}`} title={selected ? 'Quitar de la selección' : 'Añadir a la selección'} data-testid={`map-list-toggle-${a.id}`}>
      {selected ? <Check className="w-3.5 h-3.5" /> : <Plus className="w-3.5 h-3.5" />}
    </button>
    <button onClick={() => onFocus(a)} className="min-w-0 flex-1 text-left" data-testid={`map-list-focus-${a.id}`}>
      <p className="text-sm font-medium text-slate-900 truncate">{a.codigo_npl || 'Sin código'} · {a.direccion || 'Sin dirección'}</p>
      <p className="text-[11px] text-slate-500 truncate">{[a.municipio, a.provincia].filter(Boolean).join(', ')}{a.tipo_activo ? ` · ${a.tipo_activo}` : ''}</p>
    </button>
  </li>
);

const TabBtn = ({ active, onClick, children, tid }) => (
  <button onClick={onClick} className={`text-xs font-medium px-2.5 py-1.5 rounded-md transition-colors ${active ? 'bg-slate-900 text-white' : 'text-slate-600 hover:bg-slate-100'}`} data-testid={tid}>{children}</button>
);

export const MapSidebarList = ({ tab, setTab, items, sinCoords, selection, selectedIds, onToggle, onFocus, onClearSelection }) => {
  const [q, setQ] = useState('');
  const term = q.trim().toLowerCase();
  const match = (a) => !term || [a.codigo_npl, a.direccion, a.municipio].some(v => (v || '').toLowerCase().includes(term));
  const list = tab === 'seleccion' ? selection : tab === 'sin' ? sinCoords : items;
  const filtered = list.filter(match);
  return (
    <div className="flex flex-col gap-3" data-testid="map-sidebar">
      <div className="flex flex-wrap gap-1">
        <TabBtn active={tab === 'resultados'} onClick={() => setTab('resultados')} tid="map-tab-resultados">En el mapa ({items.length})</TabBtn>
        <TabBtn active={tab === 'seleccion'} onClick={() => setTab('seleccion')} tid="map-tab-seleccion">Selección ({selection.length})</TabBtn>
        <TabBtn active={tab === 'sin'} onClick={() => setTab('sin')} tid="map-tab-sin-coords">Sin localizar ({sinCoords.length})</TabBtn>
      </div>
      <input value={q} onChange={e => setQ(e.target.value)} placeholder="Filtrar esta lista…" className="input-base text-sm py-1.5" data-testid="map-list-search" />
      {tab === 'seleccion' && selection.length > 0 && (
        <button onClick={onClearSelection} className="self-start text-xs text-red-600 hover:underline flex items-center gap-1" data-testid="map-clear-selection"><Trash2 className="w-3 h-3" /> Vaciar selección</button>
      )}
      {tab === 'sin' ? (
        <>
          <p className="text-xs text-slate-500">Estos activos no tienen coordenadas y no se muestran en el mapa. Localízalos con «SOLICITAR DATOS A CATASTRO» en Base de Activos o añade un punto de acceso en su ficha.</p>
          <ul className="space-y-1" data-testid="map-sin-coords-list">
            {filtered.slice(0, MAX_ROWS).map(a => (
              <li key={a.id} className="flex items-center justify-between gap-2 px-2 py-1.5 text-sm">
                <span className="truncate text-slate-700">{a.codigo_npl || 'Sin código'} · {a.direccion || 'Sin dirección'}</span>
                <Link to={`/activos/${a.id}`} className="text-blue-700 shrink-0" title="Ver ficha"><ExternalLink className="w-3.5 h-3.5" /></Link>
              </li>
            ))}
          </ul>
        </>
      ) : (
        <ul className="space-y-0.5" data-testid="map-list">
          {filtered.slice(0, MAX_ROWS).map(a => <Row key={a.id} a={a} selected={selectedIds.has(a.id)} onToggle={onToggle} onFocus={onFocus} />)}
          {!filtered.length && <li className="text-sm text-slate-500 py-4 text-center">Sin resultados</li>}
        </ul>
      )}
      {filtered.length > MAX_ROWS && <p className="text-[11px] text-slate-400">Mostrando {MAX_ROWS} de {filtered.length}. Afina los filtros para ver el resto.</p>}
    </div>
  );
};

export default MapSidebarList;
